export const getProfileConfiguration = ({profile}) => {
    return profile.configurationData;
  };